(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
    );

  angular.module('MktzapApp.Controllers')
    .controller('ReportsChatbotCustomerJourneyController', reports);

  reports.$inject = ['$scope', '$http', 'NotificationService'];

  function reports ($scope, $http, NotificationService) {
    var vm = this;
    $scope.vm = vm;
    vm.loading = false;
    vm.nps = false;
    vm.bot0800 = false;
    vm.botNac = false;
    vm.downloadSentPassword = downloadSentPassword;

    vm.filters = {
      fromDate: moment().startOf("month").format("DD/MM/YYYY"),
      toDate: moment().endOf("month").format("DD/MM/YYYY"),
      exportMedalia: false,
      exportNac: false,
    };

    $http.get(apiUrl + '/company-country')
      .then(function ({ data, status, headers, config }) {
        vm.country = data.initials;
      }, function ({ data }) { console.log(data) })

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

     vm.changeChatbot = function () {
      if (
        String(vm.filters.chatbot) ==
        "App\\Library\\CommandProcessors\\Cetelem\\NPS\\Nps"
      ) {
        vm.nps = true;
      } else {
        vm.nps = false;
      }

      if (
        String(vm.filters.chatbot) ==
        "App\\Library\\CommandProcessors\\Cetelem\\AutoatendimentoWhatsApp\\Atendimento"
      ) {
        vm.bot0800 = true;
      } else {
        vm.bot0800 = false;
      }

      if (
        String(vm.filters.chatbot) ==
        "App\\Library\\CommandProcessors\\Cetelem\\Nac\\NacConsignado"
      ) {
        vm.botNac = true;
      } else {
        vm.botNac = false;
      }
    };

    vm.countMessages = function (lines) {
      var total = lines[lines.length - 1];
      var sum = 0;
      for (var i = 1; i < total.length; i++) {
        sum += parseInt(total[i]);
      }
      return sum;
    };

    vm.download = function (isSearch) {
      vm.filters.isSearch = isSearch;

      if (isSearch == "medaliaExport") {
        vm.filters.exportMedalia = true;
        vm.filters.isSearch = false;
      } else {
        vm.filters.exportMedalia = false;
      }

      if (isSearch == "nacExport") {
        vm.filters.exportNac = true;
        vm.filters.isSearch = false;
      } else {
        vm.filters.exportNac = false;
      }

      $http.get(apiUrl + '/reports/customer_journey/ChatbotCustomerJourney', {
        params: {
          filters: vm.filters,
          sendByEmail: false
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.success === false) {
            NotificationService.warningHandler(data, data.error_message);
            return false;
          }

          if (data.indexOf('no_records') >= 0) {
            vm.result = 0;
            NotificationService.warningHandler(data, $scope.labels.noRecordsFound);
            return;
          }

          if (isSearch && isSearch != "medaliaExport" && isSearch != "nacExport") {
            var allTextLines = data.split(/\r\n|\n/);
            var headers = allTextLines[1].split(",");
            var header = [];
            for (var x = 0; x < headers.length; x++) {
              header.push(headers[x].replace(/["]/g, ""));
            }

            var lines = [];

            if (
              vm.filters["chatbot"] ===
              "App\\Library\\CommandProcessors\\Cetelem\\AutoatendimentoWhatsApp\\Atendimento"
            ) {
              var totalCounts = allTextLines.slice(2);

              var customerJourneyByChannel = Array();

              customerJourneyArray = prepareCustomerJourney(totalCounts);

              customerJourneyArray.reverse(); // deixando reverso para obter os valores ate a quantidade total

              // tratando conforme a maneira que esta vindo do backend, tirando index e pegando array relacionado a quantidades por canais de entrada
              for (
                let index = 0;
                index < customerJourneyArray.length;
                index++
              ) {
                if (
                  customerJourneyArray[index].split(",")[0] ==
                  $scope.labels.grandTotal
                ) {
                  break;
                }
                if (
                  customerJourneyArray[index] == "" ||
                  customerJourneyArray[index] == "undefined" ||
                  customerJourneyArray[index] === null
                ) {
                  customerJourneyArray.splice(customerJourneyArray[index], 1);
                }

                customerJourneyByChannel.push(
                  customerJourneyArray[index].split(",")
                );

                if (
                  customerJourneyArray[index].split(",")[0] ==
                  $scope.labels.selectedOption
                ) {
                  customerJourneyByChannel.pop();
                }
              }
              vm.totalCounts = customerJourneyByChannel.reverse(); // ordenando array na maneira correta
            }

            for (var i = 0; i < allTextLines.length; i++) {
              if (i > 1) {
                var data = allTextLines[i].split(",");
                if (data.length == header.length) {
                  var tarr = [];
                  for (var j = 0; j < header.length; j++) {
                    tarr.push(data[j].replace(/["]/g, ""));
                  }
                  lines.push(tarr);
                }
              }
            }
            if (lines.length === 0) {
              vm.result = "no_messages";
            } else {
              vm.result = lines.length;
            }
            vm.headers = header;
            vm.data = lines;
            vm.footerSize = 1;
          } else {
            var filename =
              headers("Mktzap-Filename") || $scope.labels.fileName + ".csv";

            var anchor = angular.element("<a/>");
            anchor.css({ display: "none" });
            angular.element(document.body).append(anchor);

            var blob = new Blob([data], { type: "text/csv" });
            var csvUrl = URL.createObjectURL(blob);

            anchor
              .attr({
                href: csvUrl,
                target: "_self",
                download: filename,
              })[0]
              .click();

            anchor.remove();
            URL.revokeObjectURL(csvUrl);
          }
        }, function ({ data, status, headers, config }) {
          if (status == 504) {
            $http.get(apiUrl + '/reports/customer_journey/ChatbotCustomerJourney', {
              params: {
                filters: vm.filters,
                sendByEmail: true
              }
            })
              .then(function ({ data, status, headers, config }) {
                NotificationService.warningHandler(null, $scope.labels.alertProcessMail);
              }, function ({ data, status, headers, config }) {
                NotificationService.errorHandler(null, $scope.labels.errorRepor);
              })
          } else {
            NotificationService.errorHandler(null, $scope.labels.errorReport);
          }
        })
    };

    function downloadSentPassword() {

      $http.get(apiUrl + '/reports/sent_password_0800', {
        params: {
          filters: vm.filters,
          sendByEmail: false
        }
      })
      .then(function ({ data, status, headers, config }) {
        if (data.success === false) {
          NotificationService.warningHandler(data, data.error_message);
          return false;
        }
        if (data.indexOf('no_records') >= 0) {
          vm.result = 0;
          NotificationService.warningHandler(data, $scope.labels.noRecordsFound);
          return;
        }

        var filename = headers("Mktzap-Filename") || $scope.labels.fileName + ".csv";
        var anchor = angular.element("<a/>");
        anchor.css({ display: "none" });
        angular.element(document.body).append(anchor);

        var blob = new Blob([data], { type: "text/csv" });
        var csvUrl = URL.createObjectURL(blob);

        anchor.attr({
            href: csvUrl,
            target: "_self",
            download: filename,
          })[0]
          .click();

        anchor.remove();
        URL.revokeObjectURL(csvUrl);
      })
    }

    /**
         * Tratando Array vindo do backend, retirando aspas
         *
         * @param array array
         */
    function prepareCustomerJourney (array) {
      var customerJourney = array.map(function (elem) {
        return elem.replace('"', '');
      });
      var customerJourney = customerJourney.map(function (elem) {
        return elem.replace('"', '');
      });
      return customerJourney;
    }
  }
})();
